/**
 * Calculadora TCO EV vs ICE — Modelo VF 9.1
 */
(function () {
  'use strict';

  function initTcoCalculadora(root) {
    if (!root || root.dataset.tcoInit === 'true') return;
    if (typeof Chart === 'undefined') {
      setTimeout(boot, 50);
      return;
    }
    root.dataset.tcoInit = 'true';

// ══════════════════════════════════════════════════════════
    // CONSTANTES — Excel VF 9.1
    // ══════════════════════════════════════════════════════════
    const UF=40000,DM=30,TAX=0.27;
    const DEP_VH=5,DEP_INF=3,DEV=0.10,DICE=0.08;
    // WACC: 6.72% para proyectos <10 años, 6.83% para ≥10 años (Parámetros generales Excel VF8)
    const WACC_SHORT=0.0672, WACC_LONG=0.0683;
    function getWACC(ae){ return ae<=10?WACC_SHORT:WACC_LONG; }
    // Período evaluación por defecto
    let AE=10;
    let N_CRED=AE; // Plazo crédito/leasing — por defecto igual al período de evaluación
    // Tasas de financiamiento (Parámetros generales Excel VF8)
    const R_EV_CRED=0.0684,  R_ICE_CRED=0.0704;  // crédito: 6.84% EV, 7.04% ICE (anual UF)
    const R_EV_LEAS=0.0684,  R_ICE_LEAS=0.0704;  // leasing: mismas tasas
    
    // PMT: cuota anual = pv * r*(1+r)^n / ((1+r)^n - 1)
    function pmt(rate, n, pv){
      if(rate===0) return pv/n;
      return pv * rate * Math.pow(1+rate,n) / (Math.pow(1+rate,n)-1);
    }
    
    // Cuota anual dinámica según método y período actual
    // NOTA: Para bus en crédito, el Excel usa cuotas hardcoded (855.93 EV / 575.07 ICE)
    // que no coinciden con PMT(6.84%, AE, cv) — son valores fijos del modelo Excel.
    function getCuotaDyn(t, m, i, cv_override){
      const p=V[t];
      if(m==='compra') return 0;
      // Bus crédito: usar cuotas hardcoded del Excel (no recalcular con PMT)
      if(t==='bus' && m==='credito' && cv_override==null) return Math.abs(p.cc[i]);
      const pv = cv_override!=null ? Math.abs(cv_override) : Math.abs(p.cv[i]);
      const r   = (m==='leasing')
        ? (i===0 ? R_EV_LEAS : R_ICE_LEAS)
        : (i===0 ? R_EV_CRED : R_ICE_CRED);
      return pmt(r, N_CRED, pv);  // usa plazo crédito, no período evaluación
    }
    const CO2D=2.68,CO2G=2.31;
    // Precios electricidad libre v8
    const ELIB_NOC=109.2,ELIB_DIA=50.232;
    const PERF_BUS=0.30,PERF_CAM=0.45;
    // ep_ev calculado: bus=109.2*(1-0.3)+50.232*0.3=76.44+15.07=91.51, camión=109.2*(1-0.45)+50.232*0.45=60.06+22.60=82.66
    const EP_BUS=91.5096,EP_CAM=82.6644;
    
    // VF 9.1: DM=30, DEP_INF=3, infra bus/camión=650, bus rend=1.0, camión cpot=8000,
    // camioneta mi=6, camión mi=16.2, VR_ICE_camión=121.25, cuotas PMT dinámicas
    const V={
      automovil:{label:'Automóvil',icon:'🚗',comb:'gasolina',
        rend:[5.8,14],cp:[0.8,0],cl:[65.45,43.15],cc:[65.45,43.15],cv:[463.125,302.5],
        inf:[45,0],mk:[13.4,21.52],sm:[124865.9,72825.98],
        mi:[0,0],si:[0,0],ca:[1,0],pm:[5,5],pk:6,rp:0,cpk:0,
        cice:1067,ep_ev:null},
      furgon:{label:'Furgón',icon:'🚐',comb:'diesel',
        rend:[4.5,12],cp:[0.75,0],cl:[84.80,78.45],cc:[84.80,78.45],cv:[600,550],
        inf:[45,0],mk:[7,15],sm:[99421,76591],
        mi:[2.5,0],si:[1,0],ca:[0.5,0],pm:[7,9.5],pk:7,rp:0,cpk:8000,
        cice:985,ep_ev:null},
      bus:{label:'Bus',icon:'🚌',comb:'diesel',
        rend:[1.0,2.3],cp:[1.0,0],cl:[610.88,421.86],cc:[610.88,421.86],cv:[4322.5,2957.5],
        inf:[650,0],mk:[35,45],sm:[273000,214500],
        mi:[3.5,0],si:[1.9,0],ca:[0.25,0],pm:[2.8,2.8],pk:120,rp:0.25,cpk:8000,
        cice:900,ep_ev:EP_BUS},
      camioneta:{label:'Camioneta',icon:'🛻',comb:'diesel',
        rend:[3.6,11.5],cp:[0.7,0],cl:[114.85,86.48],cc:[114.85,86.48],cv:[812.667,606.25],
        inf:[45,0],mk:[17,23],sm:[137352.49,80108.578],
        mi:[0,0],si:[1,0],ca:[0.5,0],pm:[7.5,7.5],pk:7,rp:0,cpk:0,
        cice:985,ep_ev:null},
      camion:{label:'Camión',icon:'🚛',comb:'diesel',
        rend:[0.95,2.6],cp:[1.0,0],cl:[643.03,551.66],cc:[643.03,551.66],cv:[4550,3867.5],
        inf:[650,0],mk:[40,50],sm:[400000,300000],
        mi:[3.5,0],si:[1.9,0],ca:[0.25,0],pm:[10,10],pk:120,rp:0.25,cpk:8000,
        cice:900,ep_ev:EP_CAM,
        vrEV_override:0, vrICE_override:121.25},
    };
    
    // ══ TABLA DE SENSIBILIDAD ══
    const SENS_VARS={
      km:    {label:'Km diarios',unit:'km/día',min:50,max:600,fmt:v=>Math.round(v)+''},
      epEV:  {label:'Elec. EV',unit:'$/kWh',min:50,max:400,fmt:v=>Math.round(v)+''},
      comb:  {label:'Combustible',unit:'$/lt',min:600,max:1600,fmt:v=>Math.round(v)+''},
      rEV:   {label:'Rend. EV',unit:'km/kWh',min:0.5,max:8,fmt:v=>v.toFixed(1)},
      rICE:  {label:'Rend. ICE',unit:'km/lt',min:1,max:20,fmt:v=>v.toFixed(1)},
      cuEV:  {label:'Cuota EV',unit:'UF/año',min:50,max:1500,fmt:v=>Math.round(v)+''},
      cuICE: {label:'Cuota ICE',unit:'UF/año',min:30,max:1000,fmt:v=>Math.round(v)+''},
    };
    
    function linspace(a,b,n){const r=[];for(let i=0;i<n;i++)r.push(a+(b-a)*i/(n-1));return r;}
    
    function buildSensTable(){
      if(!$('s-var1')) return; // guard: elemento no existe aún
      const t=gv('c-tipo'),met=gv('c-met');
      const v1k=gv('s-var1'),v2k=gv('s-var2');
      const n=parseInt(gv('s-steps'));
      if(v1k===v2k&&v2k!=='none'){$('sens-table-wrap').innerHTML='<p style="color:var(--orange);padding:8px;font-size:12px">⚠ Selecciona variables diferentes para cada eje.</p>';return;}
    
      // Current values from sliders
      const t_=gv('c-tipo'),met_=gv('c-met');
      const cvEV_s=$('c-cvEV')?pf('c-cvEV'):V[t_].cv[0];
      const cvICE_s=$('c-cvICE')?pf('c-cvICE'):V[t_].cv[1];
      const cuEV_s=(met_==='compra')?0:pmt(met_==='leasing'?R_EV_LEAS:R_EV_CRED,N_CRED,cvEV_s);
      const cuICE_s=(met_==='compra')?0:pmt(met_==='leasing'?R_ICE_LEAS:R_ICE_CRED,N_CRED,cvICE_s);
      const cur={
        km:pf('c-km'),epEV:V[t_].ep_ev!=null?V[t_].ep_ev:pf('c-eev'),comb:pf('c-comb'),
        rEV:pf('c-rev'),rICE:pf('c-rice'),
        cuEV:cuEV_s, cuICE:cuICE_s,
      };
    
      const v1=SENS_VARS[v1k];
      const v1vals=linspace(v1.min,v1.max,n);
      const has2=v2k!=='none';
      const v2=has2?SENS_VARS[v2k]:null;
      const v2vals=has2?linspace(v2.min,v2.max,n):[];
    
      const styles=`
        <style>
        .sens-tbl{border-collapse:collapse;font-family:'Barlow',sans-serif;font-size:13px;width:100%;}
        .sens-tbl th{background:var(--navy);color:#fff;padding:8px 12px;text-align:center;font-weight:700;white-space:nowrap;font-size:13px;}
        .sens-tbl td{padding:7px 12px;text-align:center;font-weight:600;border:1px solid var(--border);white-space:nowrap;font-size:13px;}
        .sens-tbl tr:first-child td{font-weight:700;color:var(--navy);background:var(--surface2);}
        .s-low{background:#dbeafe;color:#1e3a8a;}
        .s-med{background:#bfdbfe;color:#1d4ed8;}
        .s-hi{background:#93c5fd;color:#1e40af;}
        .s-na{background:#e2e8f0;color:var(--text2);}
        .s-cur{outline:2px solid var(--navy);outline-offset:-2px;}
        .sens-lbl{font-weight:700;font-size:13px;color:var(--text2);text-transform:uppercase;letter-spacing:.8px;}
        </style>`;
    
      let html=styles+'<table class="sens-tbl"><thead><tr>';
    
      if(has2){
        html+=`<th>${v1.label}<br><span style="font-weight:400;font-size:12px">${v1.unit}</span></th>`;
        v2vals.forEach(v=>{html+=`<th>${v2.fmt(v)}<br><span style="font-weight:400;font-size:12px">${v2.unit}</span></th>`;});
        html+='</tr></thead><tbody>';
        v1vals.forEach(a=>{
          html+=`<tr><td class="sens-lbl">${v1.fmt(a)}</td>`;
          v2vals.forEach(b=>{
            const params={...cur};
            params[v1k]=a; params[v2k]=b;
            // If km is one of the vars, we display delta OPEX instead of km_indi
            const res=getKmIndi(t,met,params);
            const isCur=Math.abs(a-cur[v1k])<(v1.max-v1.min)/n/1.5&&Math.abs(b-cur[v2k])<(v2.max-v2.min)/n/1.5;
            const cls=res===null?'s-na':res<150?'s-low':res<300?'s-med':'s-hi';
            html+=`<td class="${cls}${isCur?' s-cur':''}">${res===null?'N/A':Math.round(res)}</td>`;
          });
          html+='</tr>';
        });
      } else {
        // Single variable: simple table
        html+=`<th>${v1.label} (${v1.unit})</th><th>Km indiferencia (km/día)</th><th>vs. actual</th></tr></thead><tbody>`;
        v1vals.forEach(a=>{
          const params={...cur}; params[v1k]=a;
          const res=getKmIndi(t,met,params);
          const isCur=Math.abs(a-cur[v1k])<(v1.max-v1.min)/n/1.5;
          const diff=res!==null?(res-getKmIndi(t,met,cur)):null;
          const cls=res===null?'s-na':res<150?'s-low':res<300?'s-med':'s-hi';
          const diffStr=diff===null?'—':(diff>=0?'+':'')+Math.round(diff)+' km/día';
          html+=`<tr><td class="sens-lbl${isCur?' s-cur':''}">${v1.fmt(a)}</td><td class="${cls}">${res===null?'N/A':Math.round(res)}</td><td style="color:${diff>=0?'var(--sky)':'var(--blue)'};font-size:12px">${diffStr}</td></tr>`;
        });
      }
      html+='</tbody></table>';
      $('sens-table-wrap').innerHTML=html;
    }
    
    function getKmIndi(t,met,params){
      const t__=gv('c-tipo');
      const epEV=params.epEV!==undefined?params.epEV:(V[t__].ep_ev!=null?V[t__].ep_ev:pf('c-eev'));
      const comb=params.comb!==undefined?params.comb:pf('c-comb');
      const rEV=params.rEV!==undefined?params.rEV:pf('c-rev');
      const rICE=params.rICE!==undefined?params.rICE:pf('c-rice');
      const cuEV=params.cuEV!==undefined?params.cuEV:getCuotaDyn(t,met,0);
      const cuICE=params.cuICE!==undefined?params.cuICE:getCuotaDyn(t,met,1);
      // When km is one of the variables, compute km_indi with the other params
      // (the km value in params is ignored — we're finding the indifference km for those params)
      const r=kmIndi(t,met,epEV,pf('c-epu'),comb,rEV,rICE,null,cuEV,cuICE);
      return r.always?0:r.never?null:r.km;
    }
    
    
    // ── HELPERS UI ──
    function sl(el,lid,u){$(lid).textContent=Math.round(parseFloat(el.value)).toLocaleString('es-CL')+' '+u;}
    function slf(el,lid,d,u){$(lid).textContent=parseFloat(el.value).toFixed(d)+' '+u;}
    function slp(el,lid){$(lid).textContent=(parseFloat(el.value)*100).toFixed(0)+'%';}
    function $(id){return root.querySelector("#"+id);}
    function gv(id){return $(id).value;}
    function pf(id){return parseFloat($(id).value);}
    function sv(id,v){$(id).value=v;}
    function f0(n){return Math.round(n).toLocaleString('es-CL');}
    function f1(n){return n.toLocaleString('es-CL',{minimumFractionDigits:1,maximumFractionDigits:1});}
    function sgn(n){return n>=0?'+':'';}
    // Keep both AE sliders in sync
    function syncAEsliders(){
      const v=AE;
      if($('g-ae')&&parseInt($('g-ae').value)!==v){ $('g-ae').value=v; if($('Lg-ae'))$('Lg-ae').textContent=v+' años'; }
      if($('c-ae')&&parseInt($('c-ae').value)!==v){ $('c-ae').value=v; if($('Lc-ae'))$('Lc-ae').textContent=v+' años'; }
      // Limitar N_CRED a AE: el plazo de crédito no puede superar el período de evaluación
      if(N_CRED>AE){ N_CRED=AE; }
      if($('g-ncred')){ $('g-ncred').max=AE; if(parseInt($('g-ncred').value)>AE){ $('g-ncred').value=AE; if($('Lg-ncred'))$('Lg-ncred').textContent=AE+' años'; } }
      if($('c-ncred')){ $('c-ncred').max=AE; if(parseInt($('c-ncred').value)>AE){ $('c-ncred').value=AE; if($('Lc-ncred'))$('Lc-ncred').textContent=AE+' años'; } }
      // Cuotas are now auto-computed from cv sliders — no update needed here
      // Recalc to refresh the cuota display
      if($('view-caso')&&$('view-caso').classList.contains('on')) recalcCaso();
    }
    function setAE(v){
      AE=parseInt(v,10)||10;
      syncAEsliders();
      recalcCaso();
      buildSensTable();
    }
    function setNCred(v){
      N_CRED=parseInt(v,10)||AE;
      recalcCaso();
      buildSensTable();
    }
    // getCuota: returns hardcoded base value (used only as reference/fallback)
    function getCuota(t,m,i){const p=V[t];return m==='leasing'?p.cl[i]:m==='credito'?p.cc[i]:0;}
    // getCuotaDefault: returns dynamically calculated cuota for current AE
    function getCuotaDefault(t,m,i){ return getCuotaDyn(t,m,i); }
    function getEpEV(t,ep,epu,elib,cp_ov){
      const p=V[t];
      if(p.ep_ev!=null) return elib; // bus/camión: precio libre terminales
      const cp=cp_ov!=null?cp_ov:p.cp[0];
      return cp*ep+(1-cp)*epu;       // otros: mix según % carga privada
    }
    
    // ── MOTOR ──
    function opex(t,kmD,epPriv,epu,cice,rEV,rICE,cp_ov,met_ov,cpk_ov){
      // ep_efectivo = mix de carga privada y red pública según % cp
      // Excel F17: IF(leasing, 0, mant+seg)
      // Excel F24: IF(leasing, 0, permiso)
      // Infra mant (F20) y energía/potencia aplican siempre
      const p=V[t],kmE=kmD*DM*12,kmM=kmD*365;
      const cp  = (cp_ov!=null)  ? cp_ov  : p.cp[0];
      const met = (met_ov!=null) ? met_ov : null;
      const cpkVal = (cpk_ov!=null) ? cpk_ov : p.cpk;
      const epEV = cp*epPriv + (1-cp)*epu;
      const eEV  = (kmE/rEV)*epEV/UF;
      const eICE = (kmE/rICE)*cice/UF;
      const pot  = p.pk*p.rp*cpkVal*12/UF;
      const im   = (p.mi[0]*p.ca[0]+p.si[0]*p.ca[0])*12; // infra mant: siempre
      // Mantenimiento + seguros + permiso: 0 en leasing (incluidos en cuota)
      const isLeas = (met==='leasing');
      const mEV  = isLeas ? 0 : (kmM*p.mk[0]+p.sm[0]*12)/UF;
      const mICE = isLeas ? 0 : (kmM*p.mk[1]+p.sm[1]*12)/UF;
      const pEV  = isLeas ? 0 : p.pm[0];
      const pICE = isLeas ? 0 : p.pm[1];
      return{eEV,eICE,epEV,pot,mEV,mICE,im,pEV,pICE,
        totEV:eEV+pot+mEV+im+pEV, totICE:eICE+mICE+pICE};
    }
    
    function calcTCO(t,kmD,met,epPriv,epu,cice,rEV,rICE,cuEV,cuICE,cp_ov,cv_ov,inf_ov,cpk_ov){
      // cv_ov=[cvEV,cvICE] and inf_ov=infEV allow user to override default vehicle costs
      const p=V[t],o=opex(t,kmD,epPriv,epu,cice,rEV,rICE,cp_ov,met,cpk_ov);
      const W=getWACC(AE);
      const cvEV_ =cv_ov?cv_ov[0]:p.cv[0];
      const cvICE_=cv_ov?cv_ov[1]:p.cv[1];
      const inf_  =inf_ov!=null?inf_ov:p.inf[0];
      const inv0EV =(met==='compra')?cvEV_+inf_:inf_;
      const inv0ICE=(met==='compra')?cvICE_:0;
      // Valor residual: para camión usar override del Excel (VR_EV=0, VR_ICE=218.251)
      // Solo aplica cuando se usan los valores por defecto (sin override de cv)
      const useVRoverride = (t==='camion' && cv_ov==null);
      const resEV =(met==='leasing')?0:(useVRoverride&&p.vrEV_override!==undefined?p.vrEV_override:Math.max(0,cvEV_ *(1-DEV *AE)));
      const resICE=(met==='leasing')?0:(useVRoverride&&p.vrICE_override!==undefined?p.vrICE_override:Math.max(0,cvICE_*(1-DICE*AE)));
      let npvEV=0,npvICE=0;
      for(let i=1;i<=AE;i++){
        const fbEV =(met==='compra'?-(o.totEV) :-(o.totEV +cuEV)) +(i===AE?resEV :0);
        const fbICE=(met==='compra'?-(o.totICE):-(o.totICE+cuICE))+(i===AE?resICE:0);
        const dVhEV =(met!=='leasing'&&i<=DEP_VH)?-(cvEV_ /DEP_VH):0;
        const dVhICE=(met!=='leasing'&&i<=DEP_VH)?-(cvICE_/DEP_VH):0;
        const dInf=(i<=DEP_INF)?-(inf_/DEP_INF):0;
        npvEV +=(fbEV -(fbEV +dVhEV +dInf)*TAX)/(1+W)**i;
        npvICE+=(fbICE-(fbICE+dVhICE      )*TAX)/(1+W)**i;
      }
      const tcoEV=-inv0EV+npvEV,tcoICE=-inv0ICE+npvICE;
      return{tcoEV,tcoICE,dTCO:tcoEV-tcoICE,o};
    }
    
    function kmIndi(t,met,epPriv,epu,cice,rEV_o,rICE_o,cp_o,cuEV_o,cuICE_o,cv_ov,inf_ov,cpk_ov){
      const p=V[t];
      const rEV=rEV_o!=null?rEV_o:p.rend[0],rICE=rICE_o!=null?rICE_o:p.rend[1];
      const cp=cp_o!=null?cp_o:p.cp[0];
      const epu_=epu!=null?epu:394.96;
      const cuEV=cuEV_o!=null?cuEV_o:getCuotaDyn(t,met,0,cv_ov?cv_ov[0]:null);
      const cuICE=cuICE_o!=null?cuICE_o:getCuotaDyn(t,met,1,cv_ov?cv_ov[1]:null);
      const d=k=>{const r=calcTCO(t,k,met,epPriv,epu_,cice,rEV,rICE,cuEV,cuICE,cp,cv_ov,inf_ov,cpk_ov);return r.tcoEV-r.tcoICE;};
      if(d(1)>=0)return{km:0,always:true};
      if(d(2000)<=0)return{km:null,never:true};
      let lo=1,hi=2000;
      for(let i=0;i<70;i++){const m=(lo+hi)/2;d(m)<0?lo=m:hi=m;if(hi-lo<0.2)break;}
      return{km:Math.round((lo+hi)/2)};
    }
    
    // ── CHARTS ──
    const CC={ev:'#00B050',ice:'#ED7D31',blue:'#136CFD',sky:'#37B6FF',navy:'#002060',
              grid:'rgba(0,32,96,0.05)',tx:'#5a6a85'};
    const pal=['#002060','#136CFD','#00B050','#ED7D31','#00B0F0'];
    const charts={};
    function dC(id){if(charts[id]){charts[id].destroy();delete charts[id];}}
    function bOpts(xl,yl){
      return{responsive:true,maintainAspectRatio:false,
        plugins:{legend:{display:false},
          tooltip:{backgroundColor:'#fff',titleColor:'#1a2540',bodyColor:'#5a6a85',
                   borderColor:'#dde4f0',borderWidth:1,padding:10,callbacks:{}}},
        scales:{
          x:{grid:{color:CC.grid},ticks:{color:CC.tx,font:{family:'Barlow',size:12}},
             title:xl?{display:true,text:xl,color:CC.tx,font:{family:'Barlow',size:12}}:{display:false}},
          y:{grid:{color:CC.grid},ticks:{color:CC.tx,font:{family:'Barlow',size:12}},
             title:yl?{display:true,text:yl,color:CC.tx,font:{family:'Barlow',size:12}}:{display:false}}
        }};
    }
    
    // ══ VISTA CASO ══
    function onTipo(){syncDef();}
    function onMetodo(){syncDef();}
    
    function syncDef(){
      const t=gv('c-tipo'),m=gv('c-met'),p=V[t];
      // Rendimientos — mismo rango para todos
      sv('c-rev',p.rend[0]);slf($('c-rev'),'Lc-rev',1,'km/kWh');
      sv('c-rice',p.rend[1]);slf($('c-rice'),'Lc-rice',1,'km/lt');
      sv('c-cp',p.cp[0]);slp($('c-cp'),'Lc-cp');
      // Energía por defecto del tipo
      // c-eev = precio electricidad PRIVADA (domiciliaria o libre terminales)
      // Para bus/camión: usa precio libre terminales (ya mezclado, cp=100%)
      // Para auto/furgón/camioneta: usa precio domiciliario (150 $/kWh); epu se aplica en opex según cp
      const epDef=p.ep_ev!=null?p.ep_ev:150;  // valor exacto del vector V sin redondear
      sv('c-eev',epDef);sl($('c-eev'),'Lc-eev','$/kWh');
      sv('c-comb',Math.round(p.cice));sl($('c-comb'),'Lc-comb','$/lt');
      // Cuota
      // Sincronizar plazo crédito
      if($("c-ncred")){ sv("c-ncred",N_CRED); $("Lc-ncred").textContent=N_CRED+" años"; }
      // Set vehicle cost defaults
      sv('c-cvEV', Math.round(p.cv[0]));  sl($('c-cvEV'), 'Lc-cvEV','UF');
      sv('c-cvICE',Math.round(p.cv[1]));  sl($('c-cvICE'),'Lc-cvICE','UF');
      sv('c-inf',  Math.round(p.inf[0])); sl($('c-inf'),  'Lc-inf',  'UF');
      // Costo potencia por defecto del tipo
      if($('c-cpot')){ sv('c-cpot',p.cpk); sl($('c-cpot'),'Lc-cpot','$/kW·mes'); }
      // Resetear precio electricidad pública al default del modelo
      sv('c-epu',395); sl($('c-epu'),'Lc-epu','$/kWh');
      // Resetear plazo crédito = AE
      N_CRED=AE; if($('c-ncred')){ sv('c-ncred',AE); $('c-ncred').max=AE; if($('Lc-ncred'))$('Lc-ncred').textContent=AE+' años'; }
      recalcCaso();
      if($('view-caso')&&$('view-caso').classList.contains('on')) buildSensTable();
    }
    
    function recalcCaso(){
      const t=gv('c-tipo'),met=gv('c-met');
      const kmD=pf('c-km'),cant=parseInt($('c-cant').value)||1;
      const rEV=pf('c-rev'),rICE=pf('c-rice'),cp=pf('c-cp');
      // Para bus/camión: usar el precio exacto del vector V (igual que el General)
      // Para otros: leer del slider c-eev (precio privado)
      const epEV=V[t].ep_ev!=null?V[t].ep_ev:pf('c-eev');
      const epu=pf('c-epu'),comb=pf('c-comb');
      const cpkInput=$('c-cpot')?pf('c-cpot'):null;  // costo potencia $/kW·mes
      // Cuota calculada desde costo vehículo + AE + tasas
      const cvEV_c=pf('c-cvEV'), cvICE_c=pf('c-cvICE');
      const cuEV =(met==='compra')?0:pmt(met==='leasing'?R_EV_LEAS :R_EV_CRED,  N_CRED, cvEV_c);
      const cuICE=(met==='compra')?0:pmt(met==='leasing'?R_ICE_LEAS:R_ICE_CRED, N_CRED, cvICE_c);
      // Update cuota display
      if($('disp-cuEV'))  $('disp-cuEV').textContent =(met==='compra'?'Compra directa':f0(cuEV) +' UF/año');
      if($('disp-cuICE')) $('disp-cuICE').textContent=(met==='compra'?'Compra directa':f0(cuICE)+' UF/año');
    
      // Para el cálculo de energía EV: si el vehículo tiene precio fijo (bus/camión) usamos el slider directo
      const cvEV_s=pf('c-cvEV'), cvICE_s=pf('c-cvICE'), inf_s=pf('c-inf');
      const cv_ov_=[cvEV_s,cvICE_s];
      const res=calcTCO(t,kmD,met,epEV,epu,comb,rEV,rICE,cuEV,cuICE,cp,cv_ov_,inf_s,cpkInput);
      const o=res.o;
      const indi=kmIndi(t,met,epEV,epu,comb,rEV,rICE,cp,cuEV,cuICE,cv_ov_,inf_s,cpkInput);
      // dO: diferencia total anual (Flujo de caja) — ahorro real EV vs ICE
      const dO=(o.totICE+cuICE)-(o.totEV+cuEV);
      const kmE=kmD*DM*12;
      const aKm=kmE>0?dO*UF/kmE:0;
      const conviene=res.tcoEV>res.tcoICE;
      const km_indi=indi.always?0:(indi.never||indi.km==null)?null:indi.km;
      const diffKm=km_indi!=null?Math.abs(kmD-km_indi):null;
    
      // Verdict
      $('c-verdict').className='verdict '+(conviene?'v-ev':'v-ice');
      $('c-vi').textContent=conviene?'⚡':'⛽';
      $('c-vt').textContent=conviene?'El EV es más conveniente':'El ICE es más conveniente';
      $('c-vd').textContent=conviene
        ?(diffKm!=null?`Con ${f0(kmD)} km/día el EV supera el umbral por ${f0(diffKm)} km/día.`:'El EV tiene menor TCO con estos parámetros.')
        :(diffKm!=null?`Faltan ${f0(diffKm)} km/día para que el EV sea conveniente.`:'El ICE resulta más conveniente.');
      $('c-vkm').textContent=indi.always?'<1':(indi.never||indi.km==null)?'N/A':f0(indi.km);
    
      // KPIs fila 1
      const dc=dO>=0?'c-green':'c-orange',dkv=dO>=0?'kv-green':'kv-orange';
      setK('kpi-do',sgn(dO)+f0(dO)+' UF/año',dc,dkv,'kpi-do-s','$'+f0(dO*UF)+' /año por veh.');
      setK('kpi-dt',sgn(dO)+f0(dO*cant)+' UF/año',dc,dkv,'kpi-dt-s','$'+f0(dO*UF*cant)+' /año total');
      setK('kpi-km',sgn(aKm)+f0(aKm)+' $/km',aKm>=0?'c-blue':'c-orange','kv-blue',null,null);
      const dT=res.tcoEV-res.tcoICE;
      setK('kpi-tco',sgn(dT)+f0(dT)+' UF',dT>=0?'c-green':'c-orange',dT>=0?'kv-green':'kv-orange',
           'kpi-tco-s',`TCO EV: ${f0(res.tcoEV)} | ICE: ${f0(res.tcoICE)} UF`);
    
      // KPIs fila 2 — adicionales
      // Payback: iteración año a año — más preciso que usar flujo del año 1
      // Acumula diferencia de flujos after-tax hasta recuperar la inversión inicial adicional
      const inv0EV_pb = (met==='compra') ? (cvEV_s+inf_s) : inf_s;
      const inv0ICE_pb= (met==='compra') ? cvICE_s : 0;
      const invDiff   = inv0EV_pb - inv0ICE_pb;
      let paybackStr='—', pbSub='años para recuperar inversión adicional EV';
      if(invDiff<=0){
        paybackStr='Inmediato'; pbSub='EV no requiere mayor inversión inicial';
      } else {
        const p_=V[t];
        const resEV_pb =(met==='leasing')?0:Math.max(0,cvEV_s*(1-DEV*AE));
        const resICE_pb=(met==='leasing')?0:Math.max(0,cvICE_s*(1-DICE*AE));
        let cumSaving=0; let pbYears=null;
        for(let i=1;i<=Math.max(AE,15);i++){
          const fbEV_i =-(o.totEV +cuEV) +(i===AE?resEV_pb :0);
          const fbICE_i=-(o.totICE+cuICE)+(i===AE?resICE_pb:0);
          const dVhEV_i=(met!=='leasing'&&i<=DEP_VH)?-(cvEV_s/DEP_VH):0;
          const dVhICE_i=(met!=='leasing'&&i<=DEP_VH)?-(cvICE_s/DEP_VH):0;
          const dInf_i=(i<=DEP_INF)?-(inf_s/DEP_INF):0;
          const fnEV_i =fbEV_i -(fbEV_i +dVhEV_i+dInf_i)*TAX;
          const fnICE_i=fbICE_i-(fbICE_i+dVhICE_i       )*TAX;
          cumSaving += (fnEV_i - fnICE_i)*UF; // $ acumulados (positivo=EV ahorra)
          if(cumSaving >= invDiff*UF && pbYears===null) pbYears=i;
        }
        if(pbYears!==null) paybackStr=pbYears+' años';
        else { paybackStr=`>${Math.max(AE,15)} años`; pbSub='La inversión no se recupera en el período'; }
      }
      setK('kpi-payback',paybackStr,'c-teal','kv-teal','kpi-pb-s',pbSub);
    
      // Ahorro acumulado 8 años (VAN diferencia)
      const ahorroVAN=Math.abs(dT)*UF*cant; // diferencia de TCO en pesos, ajustado flota
      const ahorroUF=Math.abs(dT)*cant;
    
      // Costo energía por 100 km
      const e100EV=(100/rEV)*o.epEV;  // usa precio efectivo = mix privado/público
      const e100ICE=(100/rICE)*comb;
      setK('kpi-e100',f0(e100EV)+' vs '+f0(e100ICE)+' $/100km',
           e100EV<e100ICE?'c-green':'c-orange',
           e100EV<e100ICE?'kv-green':'kv-orange',
           'kpi-e100-s',`EV ${f0(e100EV)} | ICE ${f0(e100ICE)} · Ahorro ${f0(e100ICE-e100EV)} $/100km`);
    
      // CO2
      const co2f=V[t].comb==='diesel'?CO2D:CO2G;
      const co2v=(kmE/rICE)*co2f/1000;
      $('kpi-co2v').textContent=f0(co2v)+' ton/año';
      $('kpi-co2t').textContent=f0(co2v*cant)+' ton/año';
      // Litros ahorrados
      const litv=kmE/rICE;
      $('kpi-litv').textContent=f0(litv)+' lt';
      $('kpi-litt').textContent=f0(litv*cant)+' lt';
    
      // Chart TCO cruce
      const kmMax=Math.max(500,kmD*1.6,(km_indi||0)*1.5);
      const kmRng=Array.from({length:70},(_,i)=>Math.round(5+i*(kmMax/70)));
      dC('c-tco');
      const o4=bOpts('km/día','Flujo de caja anual (UF/año)');
      o4.plugins.tooltip.mode='index';
      o4.plugins.tooltip.intersect=false;
      o4.plugins.tooltip.callbacks.label=c=>` ${c.dataset.label}: ${f0(c.parsed.y)} UF/año`;
      charts['c-tco']=new Chart($('ch-c-tco').getContext('2d'),{
        type:'line',
        data:{labels:kmRng,datasets:[
          {label:'EV',data:kmRng.map(k=>opex(t,k,epEV,epu,comb,rEV,rICE,cp,met,cpkInput).totEV+cuEV),
           borderColor:CC.blue,backgroundColor:'rgba(19,108,253,.07)',borderWidth:2.5,pointRadius:0,tension:.3,fill:true},
          {label:'ICE',data:kmRng.map(k=>opex(t,k,epEV,epu,comb,rEV,rICE,cp,met,cpkInput).totICE+cuICE),
           borderColor:CC.sky,backgroundColor:'rgba(55,182,255,.07)',borderWidth:2.5,pointRadius:0,tension:.3,fill:true}
        ]},
        options:o4,
        plugins:[{id:'vl',afterDraw(ch){
          const xs=ch.scales.x,idx=kmRng.findIndex(k=>k>=kmD);if(idx<0)return;
          const x=xs.getPixelForValue(idx),ctx=ch.ctx;
          ctx.save();ctx.strokeStyle='rgba(0,32,96,.28)';ctx.lineWidth=1.5;ctx.setLineDash([5,4]);
          ctx.beginPath();ctx.moveTo(x,ch.chartArea.top);ctx.lineTo(x,ch.chartArea.bottom);ctx.stroke();
          ctx.fillStyle='rgba(0,32,96,.65)';ctx.font='bold 11px Barlow';
          ctx.fillText(f0(kmD)+' km/día',x+5,ch.chartArea.top+14);ctx.restore();
        }}]
      });
    
      // Desglose
      dC('c-des');
      const o5=bOpts('UF/año','');o5.indexAxis='y';
      o5.plugins.tooltip.callbacks.label=c=>f1(c.parsed.x)+' UF/año';
      o5.plugins.legend={display:true,labels:{color:CC.tx,font:{family:'Barlow',size:12},boxWidth:12,padding:12}};
      charts['c-des']=new Chart($('ch-c-des').getContext('2d'),{type:'bar',data:{
        labels:['Energía/Combustible','Mantenimiento + Seguros','Potencia + Infra carga','Permiso circulación'],
        datasets:[
          {label:'EV',backgroundColor:'rgba(19,108,253,.72)',borderColor:CC.blue,borderWidth:1,borderRadius:5,
           data:[o.eEV,o.mEV,o.pot+o.im,o.pEV]},
          {label:'ICE',backgroundColor:'rgba(0,176,208,.72)',borderColor:'#00B0D0',borderWidth:1,borderRadius:5,
           data:[o.eICE,o.mICE,0,o.pICE]}
        ]},options:o5});
    }
    
    function setK(vid,val,cls,kvcls,sid,sub){
      const el=$(vid);el.textContent=val;el.className='kpi-val '+cls;
      const kpi=el.parentElement;
      kpi.className='kpi '+kvcls;
      if(sid&&sub)$(sid).textContent=sub;
    }
    
    function switchTab(name,btn){
      root.querySelectorAll('.view').forEach(v=>v.classList.remove('on'));
      root.querySelectorAll('.tab').forEach(b=>b.classList.remove('on'));
      const vEl=$('view-'+name);if(vEl)vEl.classList.add('on');btn.classList.add('on');
      if(name==='caso'){recalcCaso();buildSensTable();}
      else if(name==='ejecutivo') updateEjecutivo();
      else if(name==='escenarios') renderScenarios();
    }
    
    // Called when cv sliders change — recompute cuota display + recalc
    function onCvChange(){
      const t=gv('c-tipo'),met=gv('c-met');
      const cvEV=pf('c-cvEV'),cvICE=pf('c-cvICE');
      const cuEV =(met==='compra')?0:pmt(met==='leasing'?R_EV_LEAS :R_EV_CRED,  N_CRED, cvEV);
      const cuICE=(met==='compra')?0:pmt(met==='leasing'?R_ICE_LEAS:R_ICE_CRED, N_CRED, cvICE);
      if($('disp-cuEV'))  $('disp-cuEV').textContent =(met==='compra'?'Compra directa':f1(cuEV) +' UF/año');
      if($('disp-cuICE')) $('disp-cuICE').textContent=(met==='compra'?'Compra directa':f1(cuICE)+' UF/año');
      recalcCaso();
    }
    
    // ── EXPORT PDF ──
    function exportPDF(){
      const now=new Date();
      const d=now.toLocaleDateString('es-CL',{day:'2-digit',month:'long',year:'numeric'});
      const h=now.toLocaleTimeString('es-CL',{hour:'2-digit',minute:'2-digit'});
      const isGeneral=false;
      const viewName=isGeneral?'Vista General':'Caso Específico';
    
      // Temporarily show all views so canvas elements are rendered and have dimensions
      const allViews=root.querySelectorAll('.view');
      const prevStyles=[];
      allViews.forEach(v=>{
        prevStyles.push({el:v, display:v.style.display, vis:v.style.visibility});
        if(!v.classList.contains('on')){
          v.style.display='block';
          v.style.visibility='hidden';  // visible to browser but invisible to user
        }
      });
    
      // Give browser one frame to paint the now-visible canvases, then capture
      requestAnimationFrame(()=>{
        // Force Chart.js to resize on all now-visible canvases
        Object.values(charts).forEach(ch=>{try{ch.resize();}catch(e){}});
    
        // Small delay so charts fully re-render at correct size
        setTimeout(()=>{
          // Capture all chart canvases as PNG
          const chartImgs={};
          Object.entries(charts).forEach(([id,ch])=>{
            try{
              const canvas=ch.canvas;
              if(canvas&&canvas.width>0&&canvas.height>0){
                chartImgs[id]=canvas.toDataURL('image/png',1.0);
              }
            }catch(e){}
          });
    
          // Restore visibility before opening print window
          allViews.forEach((v,i)=>{
            if(!v.classList.contains('on')){
              v.style.display=prevStyles[i].display||'';
              v.style.visibility=prevStyles[i].vis||'';
            }
          });
    
          _openPrintWindow(chartImgs,d,h);
        }, 300);
      });
    }
    
    function _openPrintWindow(chartImgs,d,h){
      const cssHref=root.dataset.tcoCss||'';
      let bodyHtml=root.outerHTML;
      bodyHtml=bodyHtml.replace(new RegExp('<canvas id=\"([^\"]+)\"[^>]*></canvas>','g'),
        (_,id)=>chartImgs[id]?`<img class=\"chart-placeholder\" src=\"${chartImgs[id]}\" style=\"max-width:100%;height:auto;\">`:'');
      const html=`<!DOCTYPE html><html lang=\"es\"><head><meta charset=\"utf-8\"><title>Calculadora TCO</title><link href=\"https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&display=swap\" rel=\"stylesheet\">${cssHref?`<link rel=\"stylesheet\" href=\"${cssHref}\">`:''}<style>body{background:#fff!important;margin:0;}.tco-calculadora{min-height:auto;}.pdf-btn,.tabs,.tab,.vf-btn,.reset-btn,.panel{display:none!important;}.view{display:none!important;}.view.on{display:block!important;}.wrap{padding:14px 18px!important;max-width:100%!important;}.grid2{grid-template-columns:1fr!important;}.c2,.kpi-grid,.co2-row,.kpi-grid-3{grid-template-columns:repeat(2,1fr)!important;}.km-grid,.sup-grid{grid-template-columns:repeat(5,1fr)!important;}canvas{display:none!important;}.chart-placeholder{display:block!important;width:100%;text-align:center;}*{box-shadow:none!important;}.card,.kpi,.km-c{break-inside:avoid;}.print-meta{display:block!important;font-size:12px;color:#666;padding:4px 18px;background:#f8f9fc;}@page{margin:15mm;}</style></head><body>${bodyHtml}</body></html>`;
      const printWin=window.open('','_blank','width=1200,height=900');
      if(!printWin){
        alert('Tu navegador bloqueó la ventana emergente. Por favor permite las ventanas emergentes para este sitio e intenta de nuevo.');
        return;
      }
    
      printWin.document.open();
      printWin.document.write(html);
      printWin.document.close();
    
      // Update date in new window and print
      printWin.onload=()=>{
        const el=printWin.document.getElementById('print-date');
        if(el) el.textContent='Generado el '+d+' a las '+h;
        setTimeout(()=>{ printWin.print(); printWin.close(); },600);
      };
      // Fallback if onload already fired
      setTimeout(()=>{
        if(printWin&&!printWin.closed){
          const el=printWin.document.getElementById('print-date');
          if(el&&!el.textContent) el.textContent='Generado el '+d+' a las '+h;
          printWin.print();
        }
      },1500);
    }
    
    
    // ══ CASHFLOW ACUMULADO ══
    function calcCashflowAcumulado(t,kmD,met,epEV,epu,cice,rEV,rICE,cuEV,cuICE,cp_ov,cv_ov,inf_ov){
      const p=V[t],o=opex(t,kmD,epEV,epu,cice,rEV,rICE,cp_ov,met);
      const cvEV_=cv_ov?cv_ov[0]:p.cv[0],cvICE_=cv_ov?cv_ov[1]:p.cv[1],inf_=inf_ov!=null?inf_ov:p.inf[0];
      const inv0EV=(met==='compra')?cvEV_+inf_:inf_;
      const inv0ICE=(met==='compra')?cvICE_:0;
      const resEV=(met==='leasing')?0:Math.max(0,cvEV_*(1-DEV*AE));
      const resICE=(met==='leasing')?0:Math.max(0,cvICE_*(1-DICE*AE));
      // Diferencia acumulada año a año (EV - ICE), positivo = EV más barato acumulado
      let cumEV=-(inv0EV), cumICE=-(inv0ICE);
      const years=[0], cumDiff=[cumEV-cumICE];
      for(let i=1;i<=AE;i++){
        const fbEV=(met==='compra'?-(o.totEV):-(o.totEV+cuEV))+(i===AE?resEV:0);
        const fbICE=(met==='compra'?-(o.totICE):-(o.totICE+cuICE))+(i===AE?resICE:0);
        const dVhEV=(met!=='leasing'&&i<=DEP_VH)?-(cvEV_/DEP_VH):0;
        const dVhICE=(met!=='leasing'&&i<=DEP_VH)?-(cvICE_/DEP_VH):0;
        const dInf=(i<=DEP_INF)?-(inf_/DEP_INF):0;
        const fnEV=fbEV-(fbEV+dVhEV+dInf)*TAX;
        const fnICE=fbICE-(fbICE+dVhICE)*TAX;
        cumEV+=fnEV; cumICE+=fnICE;
        years.push(i);
        cumDiff.push(cumEV-cumICE);
      }
      return{years, cumDiff, cumEV, cumICE};
    }
    
    // ══ LITROS AHORRADOS ══
    function litrosAhorrados(t,kmD,rICE){
      const p=V[t];
      const kmA=kmD*DM*12;
      return kmA/rICE;  // litros/año
    }
    
    // ══ VISTA EJECUTIVA ══
    function updateEjecutivo(){
      const t=gv('c-tipo'),met=gv('c-met');
      const kmD=pf('c-km'),cant=parseInt($('c-cant').value)||1;
      const rEV=pf('c-rev'),rICE=pf('c-rice');
      const epEV=V[t].ep_ev!=null?V[t].ep_ev:pf('c-eev'),epu=pf('c-epu'),comb=pf('c-comb');
      const cp=pf('c-cp');
      // Cuota calculada desde costo vehículo + AE + tasas
      const cvEV_c=pf('c-cvEV'), cvICE_c=pf('c-cvICE');
      const cuEV =(met==='compra')?0:pmt(met==='leasing'?R_EV_LEAS :R_EV_CRED,  N_CRED, cvEV_c);
      const cuICE=(met==='compra')?0:pmt(met==='leasing'?R_ICE_LEAS:R_ICE_CRED, N_CRED, cvICE_c);
      // Update cuota display
      if($('disp-cuEV'))  $('disp-cuEV').textContent =(met==='compra'?'Compra directa':f1(cuEV) +' UF/año');
      if($('disp-cuICE')) $('disp-cuICE').textContent=(met==='compra'?'Compra directa':f1(cuICE)+' UF/año');
      const p=V[t];
      const cv_ov_e=[cvEV_c,cvICE_c], inf_e=pf('c-inf');
    
      const res=calcTCO(t,kmD,met,epEV,epu,comb,rEV,rICE,cuEV,cuICE,cp,cv_ov_e,inf_e);
      const o=res.o;
      const indi=kmIndi(t,met,epEV,epu,comb,rEV,rICE,null,cuEV,cuICE,cv_ov_e,inf_e);
      // dO: diferencia total anual (Flujo de caja) — ahorro real EV vs ICE
      const dO=(o.totICE+cuICE)-(o.totEV+cuEV);
      const kmE=kmD*DM*12;
      const aKm=kmE>0?dO*UF/kmE:0;
      const conviene=res.tcoEV>res.tcoICE;
      const km_indi=indi.always?0:(indi.never||indi.km==null)?null:indi.km;
      const diffKm=km_indi!=null?Math.abs(kmD-km_indi):null;
    
      // Badge
      const metLabels={credito:'Compra a crédito',leasing:'Leasing operativo',compra:'Compra directa'};
      $('ej-tipo-badge').textContent=p.icon+' '+p.label+' · '+metLabels[met]+' · '+f0(kmD)+' km/día';
    
      // Verdict
      $('ej-verdict').className='verdict '+(conviene?'v-ev':'v-ice');
      $('ej-vi').textContent=conviene?'⚡':'⛽';
      $('ej-vt').textContent=conviene?'El Vehículo Eléctrico es más conveniente':'El Vehículo ICE es más conveniente';
      $('ej-vd').textContent=conviene
        ?(diffKm!=null?`Con ${f0(kmD)} km/día recorridos, el EV supera el umbral de indiferencia por ${f0(diffKm)} km/día. La inversión adicional se recupera con el ahorro operacional.`:'El EV tiene menor TCO con los parámetros ingresados.')
        :(diffKm!=null?`Se necesitan ${f0(diffKm)} km/día adicionales para que el EV sea conveniente. El ICE tiene menor costo total con los km actuales.`:'El ICE resulta más conveniente con los parámetros ingresados.');
      $('ej-vkm').textContent=indi.always?'<1':(indi.never||indi.km==null)?'N/A':f0(indi.km);
    
      // Big KPIs
      $('ej-dopex').textContent=sgn(dO)+f1(dO)+' UF/año';
      $('ej-dopex').className='kpi-val '+(dO>=0?'c-green':'c-orange');
      $('ej-dopex-s').textContent='$'+f0(dO*UF)+'/año por vehículo';
      $('ej-km').textContent=sgn(aKm)+f0(aKm)+' $/km';
      $('ej-km').className='kpi-val '+(aKm>=0?'c-blue':'c-orange');
      // Payback
      // Payback ejecutivo — itera año a año (consistente con caso específico)
      const inv0EV_ej=(met==='compra')?(cvEV_c+inf_e):inf_e;
      const inv0ICE_ej=(met==='compra')?cvICE_c:0;
      const invDiff_ej=inv0EV_ej-inv0ICE_ej;
      let pbStr='—';
      if(invDiff_ej<=0){ pbStr='Inmediato'; }
      else {
        const resEV_ej =(met==='leasing')?0:Math.max(0,cvEV_c*(1-DEV*AE));
        const resICE_ej=(met==='leasing')?0:Math.max(0,cvICE_c*(1-DICE*AE));
        let cumSav_ej=0; let pbY_ej=null;
        for(let i=1;i<=Math.max(AE,15);i++){
          const fbE_ej=-(o.totEV +cuEV)+(i===AE?resEV_ej:0);
          const fbI_ej=-(o.totICE+cuICE)+(i===AE?resICE_ej:0);
          const dVhE_ej=(met!=='leasing'&&i<=DEP_VH)?-(cvEV_c/DEP_VH):0;
          const dVhI_ej=(met!=='leasing'&&i<=DEP_VH)?-(cvICE_c/DEP_VH):0;
          const dInf_ej=(i<=DEP_INF)?-(inf_e /DEP_INF):0;
          const fnE_ej=fbE_ej-(fbE_ej+dVhE_ej+dInf_ej)*TAX;
          const fnI_ej=fbI_ej-(fbI_ej+dVhI_ej       )*TAX;
          cumSav_ej+=(fnE_ej-fnI_ej)*UF;
          if(cumSav_ej>=invDiff_ej*UF&&pbY_ej===null) pbY_ej=i;
        }
        if(pbY_ej!==null) pbStr=pbY_ej+' años';
        else pbStr=`>${Math.max(AE,15)} años`;
      }
      $('ej-pb').textContent=pbStr;
      // CO2
      const co2f=p.comb==='diesel'?CO2D:CO2G;
      const co2v=(kmE/rICE)*co2f/1000;
      $('ej-co2').textContent=f1(co2v*cant);
      $('ej-co2-s').textContent='ton/año ('+(cant>1?'flota de '+cant+' vehículos':'1 vehículo')+')';
    
      // Energy per 100 km
      const e100ev=(100/rEV)*o.epEV;
      const e100ice=(100/rICE)*comb;
      $('ej-e100ev').textContent=f0(e100ev);
      $('ej-e100ice').textContent=f0(e100ice);
    
      // Liters saved
      const lits=litrosAhorrados(t,kmD,rICE);
      $('ej-litv').textContent=f0(lits)+' lt/año';
      $('ej-litt').textContent=f0(lits*cant)+' lt/año';
    
      // Cashflow chart
      const cf=calcCashflowAcumulado(t,kmD,met,epEV,epu,comb,rEV,rICE,cuEV,cuICE,cp,cv_ov_e,inf_e);
      dC('ej-cf');
      const breakEven=cf.cumDiff.findIndex(v=>v>=0);
      const o6=bOpts('Año','Diferencia acumulada TCO (UF)');
      o6.plugins.tooltip.callbacks.label=c=>' Diferencia acumulada: '+sgn(c.parsed.y)+f0(c.parsed.y)+' UF';
      o6.scales.y.grid={color:v=>v.tick.value===0?'rgba(0,32,96,0.3)':'rgba(0,32,96,0.05)',lineWidth:v=>v.tick.value===0?1.5:1};
      charts['ej-cf']=new Chart($('ch-ej-cf').getContext('2d'),{
        type:'line',
        data:{
          labels:cf.years.map(y=>'Año '+y),
          datasets:[{
            label:'Diferencia EV − ICE (acumulada)',
            data:cf.cumDiff,
            borderColor:CC.blue,
            backgroundColor:cf.cumDiff.map(v=>v>=0?'rgba(19,108,253,0.12)':'rgba(237,125,49,0.12)'),
            borderWidth:2.5,pointRadius:4,pointBackgroundColor:cf.cumDiff.map(v=>v>=0?CC.blue:CC.sky),
            tension:.3,fill:true
          }]
        },
        options:o6,
        plugins:[{id:'zero',afterDraw(ch){
          const ys=ch.scales.y,xs=ch.scales.x;
          const y0=ys.getPixelForValue(0);
          const ctx=ch.ctx;
          ctx.save();
          ctx.strokeStyle='rgba(0,32,96,0.4)';ctx.lineWidth=1.5;ctx.setLineDash([4,3]);
          ctx.beginPath();ctx.moveTo(xs.left,y0);ctx.lineTo(xs.right,y0);ctx.stroke();
          if(breakEven>0){
            const x=xs.getPixelForValue(breakEven);
            ctx.strokeStyle='rgba(0,176,80,0.6)';ctx.lineWidth=2;ctx.setLineDash([]);
            ctx.beginPath();ctx.moveTo(x,ch.chartArea.top);ctx.lineTo(x,ch.chartArea.bottom);ctx.stroke();
            ctx.fillStyle='rgba(0,176,80,0.85)';ctx.font='bold 11px Barlow';
            ctx.fillText('Punto de recuperación: Año '+breakEven,x+5,ch.chartArea.top+16);
          }
          ctx.restore();
        }}]
      });
    
      // Supuestos compactos
      const sups=[
        ['Rendimiento EV',f1(rEV)+' km/kWh'],
        ['Rendimiento ICE',f1(rICE)+' km/lt'],
        ['Electricidad EV',f0(epEV)+' $/kWh'],
        ['Combustible ICE',f0(comb)+' $/lt'],
        ['Cuota EV',f1(cuEV)+' UF/año'],
        ['Cuota ICE',f1(cuICE)+' UF/año'],
        ['Período',AE+' años · WACC '+(getWACC(AE)*100).toFixed(2)+'%'],
        ['WACC',(getWACC(AE)*100).toFixed(2)+'% (UF real)'],
        ['Impuesto','27% (comercial)'],
        ['Dep. acelerada','5 años'],
      ];
      $('ej-supuestos').innerHTML=sups.map(([k,v])=>
        `<div style="background:var(--surface2);border:1px solid var(--border);border-radius:7px;padding:8px 14px;font-size:13px;"><span style="color:var(--text2)">${k}: </span><strong>${v}</strong></div>`
      ).join('');
    }
    
    // ══ COMPARACIÓN ESCENARIOS ══
    const scenarios=[];
    const scenarioColors=['#136CFD','#00B050','#ED7D31','#002060'];
    
    function addScenario(){
      if(scenarios.length>=3){alert('Máximo 3 escenarios permitidos.');return;}
      // Copy current caso values
      const t=gv('c-tipo'),met=gv('c-met');
      const cvEV=pf('c-cvEV'),cvICE=pf('c-cvICE');
      const cuEV=(met==='compra')?0:pmt(met==='leasing'?R_EV_LEAS:R_EV_CRED,N_CRED,cvEV);
      const cuICE=(met==='compra')?0:pmt(met==='leasing'?R_ICE_LEAS:R_ICE_CRED,N_CRED,cvICE);
      const sc={
        id:Date.now(),
        tipo:t, met:met,
        label:'Escenario '+(scenarios.length+1),
        kmD:pf('c-km'), cant:parseInt($('c-cant').value)||1,
        rEV:pf('c-rev'), rICE:pf('c-rice'),
        epEV:V[t].ep_ev!=null?V[t].ep_ev:pf('c-eev'), epu:pf('c-epu'), cp:pf('c-cp'), comb:pf('c-comb'),
        cvEV:cvEV, cvICE:cvICE, inf:pf('c-inf'),
        cuEV:cuEV, cuICE:cuICE,
        cpk:$('c-cpot')?pf('c-cpot'):null,
        color:scenarioColors[scenarios.length]
      };
      scenarios.push(sc);
      renderScenarios();
    }
    
    function removeScenario(id){
      const idx=scenarios.findIndex(s=>s.id===id);
      if(idx>=0) scenarios.splice(idx,1);
      // Relabel
      scenarios.forEach((s,i)=>{ if(s.label.startsWith('Escenario')) s.label='Escenario '+(i+1); });
      renderScenarios();
    }
    
    function renderScenarios(){
      const cont=$('scenarios-container');
      cont.innerHTML='';
      if(scenarios.length===0){
        cont.innerHTML='<div style="grid-column:1/-1;text-align:center;padding:40px;color:var(--text2);font-size:13px;">No hay escenarios. Ve a <strong>Caso Específico</strong>, configura los parámetros y presiona <strong>+ Agregar escenario</strong>.</div>';
        $('scenarios-comparison').innerHTML='';
        return;
      }
      const metLabels={credito:'Crédito',leasing:'Leasing',compra:'Compra'};
      scenarios.forEach((sc,i)=>{
        const p=V[sc.tipo];
        const cp_sc=sc.cp!=null?sc.cp:V[sc.tipo].cp[0];
        const cv_sc=[sc.cvEV,sc.cvICE];
        const inf_sc=sc.inf!=null?sc.inf:V[sc.tipo].inf[0];
        const cuEV_sc=sc.cuEV!=null?sc.cuEV:((sc.met==='compra')?0:pmt(sc.met==='leasing'?R_EV_LEAS:R_EV_CRED,N_CRED,cv_sc[0]));
        const cuICE_sc=sc.cuICE!=null?sc.cuICE:((sc.met==='compra')?0:pmt(sc.met==='leasing'?R_ICE_LEAS:R_ICE_CRED,N_CRED,cv_sc[1]));
        const res=calcTCO(sc.tipo,sc.kmD,sc.met,sc.epEV,sc.epu||394.96,sc.comb,sc.rEV,sc.rICE,cuEV_sc,cuICE_sc,cp_sc,cv_sc,inf_sc,sc.cpk);
        const o=res.o; const dO=(o.totICE+cuICE_sc)-(o.totEV+cuEV_sc);
        const kmE=sc.kmD*DM*12;
        const aKm=kmE>0?dO*UF/kmE:0;
        const indi=kmIndi(sc.tipo,sc.met,sc.epEV,sc.epu||394.96,sc.comb,sc.rEV,sc.rICE,cp_sc,cuEV_sc,cuICE_sc,cv_sc,inf_sc,sc.cpk);
        const conviene=res.tcoEV>res.tcoICE;
        const co2f=p.comb==='diesel'?CO2D:CO2G;
        const co2v=(kmE/sc.rICE)*co2f/1000;
        const lits=kmE/sc.rICE;
        const kmStr=indi.always?'<1':(indi.never||indi.km==null)?'N/A':f0(indi.km);
    
        cont.innerHTML+=`<div class="card" style="border-top:4px solid ${sc.color};">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
            <div>
              <div style="font-size:14px;font-weight:800;color:var(--navy)">${sc.label}</div>
              <div style="font-size:12px;color:var(--text2)">${p.icon} ${p.label} · ${metLabels[sc.met]} · ${f0(sc.kmD)} km/día</div>
            </div>
            <div style="display:flex;align-items:center;gap:8px;">
              <span style="font-size:18px">${conviene?'⚡':'⛽'}</span>
              <button onclick="removeScenario(${sc.id})" style="padding:4px 10px;background:none;border:1px solid var(--border);border-radius:6px;cursor:pointer;font-size:12px;color:var(--text2)">✕</button>
            </div>
          </div>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
            <div style="background:var(--surface2);border-radius:8px;padding:10px 12px;">
              <div style="font-size:12px;color:var(--text2);text-transform:uppercase;font-weight:600">Km indiferencia</div>
              <div style="font-size:22px;font-weight:800;color:var(--navy)">${kmStr}</div>
              <div style="font-size:12px;color:var(--text2)">km/día</div>
            </div>
            <div style="background:var(--surface2);border-radius:8px;padding:10px 12px;">
              <div style="font-size:12px;color:var(--text2);text-transform:uppercase;font-weight:600">Δ Costo anual (Flujo de caja)</div>
              <div style="font-size:22px;font-weight:800;color:${dO>=0?'var(--blue)':'var(--orange)'}">${sgn(dO)+f0(dO)} UF</div>
              <div style="font-size:12px;color:var(--text2)">$${f0(dO*UF)}/año</div>
            </div>
            <div style="background:var(--surface2);border-radius:8px;padding:10px 12px;">
              <div style="font-size:12px;color:var(--text2);text-transform:uppercase;font-weight:600">Ahorro $/km</div>
              <div style="font-size:22px;font-weight:800;color:${aKm>=0?'var(--blue)':'var(--orange)'}">${sgn(aKm)+f0(aKm)}</div>
              <div style="font-size:12px;color:var(--text2)">$/km</div>
            </div>
            <div style="background:var(--surface2);border-radius:8px;padding:10px 12px;">
              <div style="font-size:12px;color:var(--text2);text-transform:uppercase;font-weight:600">CO₂ evitado</div>
              <div style="font-size:22px;font-weight:800;color:var(--navy)">${f0(co2v*sc.cant)}</div>
              <div style="font-size:12px;color:var(--text2)">ton/año</div>
            </div>
          </div>
          <div style="margin-top:10px;padding:8px 12px;background:var(--surface2);border-radius:8px;font-size:12px;color:var(--text2);">
            🛢 <strong>${f0(lits*sc.cant)} lt/año</strong> ahorrados · Rend. EV: ${sc.rEV} km/kWh · ICE: ${sc.rICE} km/lt · Elec: ${f0(sc.epEV)} $/kWh
          </div>
        </div>`;
      });
    
      // Comparison chart if 2+ scenarios
      if(scenarios.length>=2){
        renderScenarioChart();
      } else {
        $('scenarios-comparison').innerHTML='';
      }
    }
    
    function renderScenarioChart(){
      // Destroy existing chart BEFORE rebuilding the DOM
      dC('sc-comp');
      const comp=$('scenarios-comparison');
      comp.innerHTML='<div class="card" style="margin-top:4px;"><div class="card-ttl">Comparación OPEX + Cuota Anual vs Km diarios</div><div class="card-sub" style="margin-bottom:10px">Curvas EV (sólido) e ICE (punteado) por escenario</div><div style="position:relative;height:280px;"><canvas id="ch-sc-comp"></canvas></div></div>';
    
      const kmRng=Array.from({length:60},(_,i)=>Math.round(5+i*25));
      const ds=[];
      scenarios.forEach((sc)=>{
        const cv_sc=[sc.cvEV,sc.cvICE];
        const cuEV_sc=sc.cuEV!=null?sc.cuEV:((sc.met==='compra')?0:pmt(sc.met==='leasing'?R_EV_LEAS:R_EV_CRED,N_CRED,cv_sc[0]));
        const cuICE_sc=sc.cuICE!=null?sc.cuICE:((sc.met==='compra')?0:pmt(sc.met==='leasing'?R_ICE_LEAS:R_ICE_CRED,N_CRED,cv_sc[1]));
        ds.push({label:sc.label+' EV',borderColor:sc.color,borderWidth:2.5,pointRadius:0,tension:.3,backgroundColor:'transparent',
          data:kmRng.map(k=>opex(sc.tipo,k,sc.epEV,sc.epu||394.96,sc.comb,sc.rEV,sc.rICE,sc.cp!=null?sc.cp:1.0,sc.met,sc.cpk).totEV+cuEV_sc)});
        ds.push({label:sc.label+' ICE',borderColor:sc.color,borderWidth:1.5,borderDash:[5,3],pointRadius:0,tension:.3,backgroundColor:'transparent',
          data:kmRng.map(k=>opex(sc.tipo,k,sc.epEV,sc.epu||394.96,sc.comb,sc.rEV,sc.rICE,sc.cp!=null?sc.cp:1.0,sc.met,sc.cpk).totICE+cuICE_sc)});
      });
      // Use requestAnimationFrame to ensure new canvas is in DOM before Chart.js runs
      requestAnimationFrame(()=>{
        const canvas=root.querySelector('#ch-sc-comp');
        if(!canvas) return;
        const o7=bOpts('km/día','Flujo de caja anual (UF/año)');
        o7.plugins.legend={display:true,labels:{color:CC.tx,font:{family:'Barlow',size:12},boxWidth:14,padding:10}};
        o7.plugins.tooltip.mode='index';
        o7.plugins.tooltip.intersect=false;
        o7.plugins.tooltip.callbacks.label=ctx=>ctx.dataset.label+': '+f0(ctx.parsed.y)+' UF/año';
        charts['sc-comp']=new Chart(canvas.getContext('2d'),{
          type:'line',data:{labels:kmRng,datasets:ds},options:o7});
      });
    }
    

    syncDef();

    const handlers = {
      switchTab, syncDef, onTipo, onMetodo, onCvChange, buildSensTable, syncAEsliders,
      setAE, setNCred,
      addScenario, removeScenario, exportPDF, recalcCaso,
      sl, slf, slp
    };
    Object.keys(handlers).forEach(function (key) {
      window[key] = handlers[key];
    });
  }

  function boot() {
    document.querySelectorAll('[data-tco-calculadora]').forEach(initTcoCalculadora);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
